import { breakpoints } from 'common/styles/breakpoints';
import { css } from 'linaria';

export const sectionStyle = css`
  margin: -20px 0 20px;
  ${breakpoints.from.desktop} {
    margin: var(--space-300) 0;
  }
`;
